module.exports = __webpack_public_path__ + "static/media/logo.1fd550e9.svg";